import { Typography } from 'opensolar-ui'
import { useTranslate } from 'ra-core'

const Subtitle = ({ subtitle }) => {
  const translate = useTranslate()
  return subtitle ? (
    <Typography
      variant="body2"
      style={{
        color: 'rgba(0, 0, 0, 0.54)',
        margin: 0,
        marginBottom: 10,
      }}
    >
      {typeof subtitle === 'string' ? translate(subtitle) : subtitle}
    </Typography>
  ) : null
}

export default Subtitle
